export const ENTRIES = 'entries';